/**
 * Provides service functions for managing the user onboarding tour,
 * including determining whether the tour should be displayed and recording
 * when the tour has been completed or shown.
 */
import { api } from "@/api";

export interface UserTourDecisionResponse {
  showTour: boolean;
  reason?: string;
}

export interface UserTourShownResponse {
  success: boolean;
}

export async function getUserTourDecision(
  userPrincipalName: string
): Promise<UserTourDecisionResponse> {
  const res = await api.getUserTourDecision(userPrincipalName);
  return res as UserTourDecisionResponse;
}

export async function postUserTourShown(userPrincipalName: string): Promise<UserTourShownResponse> {
  const res = await api.postUserTourShown(userPrincipalName);
  return res as UserTourShownResponse;
}
